import { DropdownListV2, DropdownTrigger } from "@drone-js/core";
import { useDisclosure } from "apps/commons/hooks/useDisclosure";
import type { PayoutItem, PayoutItemMethodEnum } from "libs/codegen/property-onboarding";
import { OneOnboardingImages } from "libs/images/oneOnboarding";
import groupBy from "lodash/groupBy";
import type { FunctionComponent } from "react";
import { useStaticDataAtomValue } from "../../staticDataAtom";
import { PayoutGroup } from "./PayoutGroup";
import { payoutMethodMapper } from "./constants";
import { getPayoutLabel } from "./getPayoutLabel";

interface Props {
    value: PayoutItem;
    setValue: (value: PayoutItem) => void;
    payoutItems: PayoutItem[];
}

export const ExistingPayout: FunctionComponent<Props> = ({ payoutItems, value, setValue }) => {
    const { open, setOpen: onVisibilityChange, onClose } = useDisclosure();
    const {
        cmsData: {
            pricing: { bankTransfer, myPayouts, payout },
        },
    } = useStaticDataAtomValue();

    const groupedPayoutItems: Partial<Record<PayoutItemMethodEnum, PayoutItem[]>> = groupBy(
        payoutItems ?? [],
        (item) => item.method,
    );

    const mappedValue = value ? payoutItems.find((item) => item.id === value.id) : null;
    const valueLabel = mappedValue ? getPayoutLabel(mappedValue) : undefined;

    const handleSelect = (value: PayoutItem) => {
        setValue(value);
        onClose();
    };

    const leadingAsset =
        mappedValue?.method === payoutMethodMapper.BankTransfer
            ? {
                  src: OneOnboardingImages.PayoutBank,
              }
            : mappedValue?.method === payoutMethodMapper.PayPal
              ? {
                    src: OneOnboardingImages.PayoutPayPal,
                }
              : undefined;

    return (
        <DropdownListV2
            title={myPayouts}
            visible={open}
            items={
                <>
                    <PayoutGroup
                        a11yGroup="bank-transfer"
                        title={bankTransfer}
                        icon={OneOnboardingImages.PayoutBank}
                        items={groupedPayoutItems[payoutMethodMapper.BankTransfer]}
                        onSelect={handleSelect}
                    />
                </>
            }
            onChange={() => {}}
            onVisibilityChange={onVisibilityChange}
            closeButton={{
                "aria-label": "Close",
            }}
            padding="s"
        >
            <DropdownTrigger label={payout} placeholder="Not selected" value={valueLabel} leadingAsset={leadingAsset} />
        </DropdownListV2>
    );
};
